import { ArrowLeftIcon } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { PageHeader } from '@/components/layout/page-header'
import { Icon } from '@/components/ui/icon'
import { Link } from '@/components/ui/link'
import { selectActiveBuilding } from '@/reducers/buildingSelectorReducer'

export const FinancialsHeader = () => {
  const { t } = useTranslation(['communication'])
  const selectedBuilding = useSelector(selectActiveBuilding)

  return (
    <PageHeader
      title={t('communication:financials.title')}
      backButton={
        <Link
          navigateBack
          use="secondary"
          size="small"
          to={{
            params: {
              buildingId: selectedBuilding?.id ?? '',
            },
            path: '/dashboard/building-dashboard/rewards/gift-cards/:buildingId',
          }}
        >
          <Icon icon={ArrowLeftIcon} />
          {t('communication:financials.back')}
        </Link>
      }
    />
  )
}
